import {StyleSheet} from 'react-native';
import {colors} from '../../assets/colors';

const styles = StyleSheet.create({
  text: {
    fontSize: 20,
    color: colors.emphasis,
  },
});

export default styles;
